<template>
  <v-container fluid>
    <v-card>
      <v-card-title
        primary-title
        style="padding-left: 8px; padding-bottom: 8px"
      >
        <span class="headline mb-0">納入指示メール送信</span>
      </v-card-title>

      <v-card-actions>
        <v-btn @click="search" class="btn-search" v-permit.SHARP_DIM_SEARCH>{{
          $t('app.buttons.search')
        }}</v-btn>
        <v-btn @click="back" v-if="false">{{ $t('app.buttons.back') }}</v-btn>
        <v-btn
          :disabled="selected.length === 0"
          @click="send"
          v-permit.SHARP_DIM_SEND_MAIL
          >送信</v-btn
        >
        <v-btn
          :disabled="selected.length === 0 || hasAllUnpaidWarehouseTransport"
          @click="cancelSend"
          v-permit.SHARP_DIM_RELEASE_MAIL
          >送信解除</v-btn
        >
        <v-spacer></v-spacer>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                label="納入指示者"
                url="employees/kv?types=SHARP,SJL"
                v-model="query.operateDirectorId"
              />
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="D/O NO"
                v-model="query.doNo"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                :label="$t('app.labels.blNo')"
                clearable
                v-model="query.blNo"
              ></v-text-field>
            </v-flex>
            <v-flex
              v-if="
                $store.getters.user.roles.every(
                  (r) => r.roleCode !== 'ROLE_PARTNER'
                )
              "
              xs3
            >
              <remote-autocomplete
                :label="$t('app.labels.partner')"
                url="companies/kvt?type=PARTNER"
                v-model="query.partnerId"
              />
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                :label="$t('app.labels.bu.name')"
                url="divisions/kv?type=BU"
                v-model="query.buHeadquartersId"
              />
            </v-flex>
          </v-layout>
          <message-alert ref="message"></message-alert>
        </v-container>
      </v-form>
    </v-card>

    <v-card class="mt-2">
      <v-data-table
        :headers="headers"
        :items="results"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        class="inline-edit"
        item-key="id"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              hide-details
              primary
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td>{{ props.item.buCode }}:{{ props.item.buName }}</td>
          <td>{{ props.item.doNo }}</td>
          <td>{{ props.item.blNo }}</td>
          <td>
            {{
              props.item.shipmentType === 'PARTNERSA'
                ? props.item.actStatus
                : props.item.status
            }}
          </td>
          <td>{{ props.item.containerNos }}</td>
          <td>{{ props.item.partnerName }}</td>
          <td>{{ props.item.primarySkuCode }}</td>
          <td>{{ props.item.etd }}</td>
          <td>{{ props.item.eta }}</td>
          <td>{{ props.item.dischargePortCode }}</td>
          <td>{{ props.item.transportModeCode }}</td>
          <td>
            {{
              props.item.totalGW | currency({ symbol: '', fractionCount: 3 })
            }}
          </td>
          <td>{{ props.item.customsDirectorName }}</td>
          <td>{{ props.item.senderName }}</td>
          <td>{{ props.item.sendDate }}</td>
          <td class="justify-center layout px-0">
            <v-btn @click="toDetail(props.item)">B/L 詳細</v-btn>
          </td>
        </template>
      </v-data-table>
    </v-card>

    <b-l-detail @refresh="load" ref="blDetail"></b-l-detail>
    <directors @refresh="load" ref="directors"></directors>

    <message-alert ref="message"></message-alert>
  </v-container>
</template>
<script>
import BLDetail from './BLDetail'
import InputDoNo from './InputDoNo'
import Directors from './Directors'

export default {
  components: { BLDetail, InputDoNo, Directors },
  methods: {
    isAllUnpaidWarehouseTransport(item) {
      return (
        item.isAllUnpaid &&
        item.specialId &&
        item.specialId.indexOf('WAREHOUSE_TRANSPORT') !== -1
      )
    },
    save() {
      Promise.all(
        this.results.map((s) => {
          return this.$http.put(`/shipping-advices/${s.id}`, s)
        })
      )
    },
    toDetail(item) {
      this.$refs.directors.popup(item.id)
    },
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable(),
        },
      }
    },
    load() {
      this.query.moduleCode = 'F500'
      this.autoload = true
      this.$storeParams()
      this.loading = true
      this.results = []
      return this.$http
        .get('/shipping-advices?view=B0500', this.params())
        .then((res) => {
          this.pagination.page = res.data.number + 1
          this.pagination.rowsPerPage = res.data.size
          this.pagination.totalItems = res.data.totalElements
          this.results = res.data.content
          this.loading = false
          this.selected = []
        })
    },
    search() {
      this.pagination.page = 0
      this.load()
    },
    openDoNo() {
      this.$refs.doNo.popup()
    },
    send() {
      if (this.hasAllUnpaidWarehouseTransport) {
        this.$message('', '倉庫間転送のデータなので、当該操作は不要です。')
        return
      }
      if (this.selected.length === 0) {
        this.$message('', '一つのレコードを選んでください。')
        return
      }
      if (this.sendedOk) {
        this.$message('', '既に送信済み。')
        return
      }
      if (!this.hasDirector) {
        this.$message('', '納入指示者を設定ください。')
        return
      }
      Promise.all(
        this.selected.map((s) => {
          return this.$http
            .post(`delivery-orders/create-do?said=${s.id}&version=${s.version}`)
            .then(() => {
              this.$message('', '指示Mail送信済')
            })
            .catch((err) => {
              this.$showError(err)
            })
        })
      ).then(() => {
        this.selected = []
        this.load()
      })
    },
    cancelSend() {
      if (this.selected.length === 0) {
        this.$message('', '一つのレコードを選んでください。')
        return
      }
      if (!this.sendedOk) {
        this.$message('', '未送信のため、送信解除出来ません。')
        return
      }
      Promise.all(
        this.selected.map((s) => {
          return this.$http.delete(
            `/delivery-orders/${s.id}/email-status-release?version=${s.version}`
          )
        })
      )
        .then(() => {
          this.selected = []
          this.load()
          this.$message('指示Mail送信解除', '指示Mail送信解除。')
        })
        .catch((res) => this.showError(res))
    },
    // setDirectors(id, item) {
    //   console.log(item)
    //   return this.$http
    //     .put(`shipping-advices/${id}/set-delivery-director`, item)
    //     .then(() => {
    //       this.load()
    //     })
    // },
    back() {
      this.$router.go(-1)
    },
    showError(res) {
      if (res.response.data.message) {
        if (res.response.data.message === 'SHIPMENT_HAS_CHANGED') {
          this.$showError(res)
          return
        }
        this.$message(
          this.$t('app.messages.errors.title'),
          res.response.data.message + 'の為、送信解除できません'
        )
      } else {
        this.$message(this.$t('app.messages.errors.title'), 'System Error.')
      }
    },
  },
  mounted() {
    this.$loadParams()
    var blNo = this.$route.query.blNo
    if (blNo) {
      this.query.blNo = blNo
      this.load()
    }
    //this.load()
  },
  watch: {
    pagination() {
      if (this.autoload) this.load()
    },
  },
  computed: {
    hasAllUnpaidWarehouseTransport() {
      return (
        this.selected.filter((item) => this.isAllUnpaidWarehouseTransport(item))
          .length > 0
      )
    },
    hasDirector() {
      return this.selected.every((s) => s.deliveryDirectorCount > 0)
    },
    sendOk() {
      return this.selected.every((s) => s.status !== '指示Mail送信済')
    },
    sendedOk() {
      return this.selected.every(
        (s) => s.status === '指示Mail送信済' || s.actStatus === '指示Mail送信済'
      )
    },
  },
  data() {
    return {
      loading: false,
      results: [],
      shipment: [],
      order: {},
      orders: [],
      selected: [],
      doNo: '',
      mail: {},
      query: {
        moduleCode: 'F500',
      },
      headers: [
        { text: '事業本部', value: 'buName', sortable: false },
        { text: 'D/O NO', value: 'doNo', sortable: false },
        { text: 'B/L NO', value: 'blNo', sortable: false },
        { text: '送信状態', value: 'status', sortable: false },
        { text: 'コンテナNO', value: 'containerNo', sortable: false },
        { text: '海外取引先', value: 'partnerName', sortable: false },
        { text: '代表品番', value: 'item', sortable: false },
        { text: 'ETD', value: 'etd', sortable: false },
        { text: 'ETA', value: 'eta', sortable: false },
        { text: '陸揚港', value: 'dischargePortCode', sortable: false },
        { text: '運送形態', value: 'transportModeCode', sortable: false },
        { text: 'Total G/W', value: 'totalGW', sortable: false },
        { text: '通関業者', value: 'operateDirectorName', sortable: false },
        { text: '送信者', value: 'senderName', sortable: false },
        { text: '送信時間', value: 'sendDate', sortable: false },
        { text: '詳細仕分', value: '', sortable: false },
      ],
      pagination: {
        rowsPerPage: 10,
      },
      errors: {
        DO_HAS_BEEN_USED: '納入指示済の為、送信解除できません',
        EMPTY_CONTAINER_NO: 'INV P/L情報が不整備です、ご確認お願いします。',
        SHIPMENT_HAS_CHANGED:
          '当該データのステータスは更新されたため、画面更新してからもう一度お試してください。',
      },
    }
  },
}
</script>
